import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { CustomSVG } from 'components';
import { ContentInput } from 'api';

import { usePostContext } from '../../PostContext';
import Widget from './WidgetContainer';
import { Switch } from '../';
import { hasVideo } from 'features/content/helpers';

const Sharing: FC = () => {
  const { values } = useFormikContext<ContentInput>();
  const { state, dispatch } = usePostContext();

  function onChangeSwitch() {
    dispatch({ type: 'share', value: !state.share });
  }

  if (hasVideo(values)) {
    return null;
  }

  return (
    <Grid item xs>
      <Widget
        titleKey="posting:shareSocialNetwork"
        subtitleKey="posting:guidelineNetwork"
        icon={<CustomSVG name="share" color={state.share ? 'inherit' : 'disabled'} />}
        toggle={<Switch checked={state.share} onChange={onChangeSwitch} color="primary" />}
      />
    </Grid>
  );
};

export default Sharing;
